<template>
  <div>
    <a-row type="flex" justify="space-between">
      <a-col :span="24">
        <a-row type="flex" justify="space-between" align="bottom" style="margin-bottom: 30px">
          <a-col :span="14" class="titulo">Países</a-col>
          <a-col><a-button type="primary" size="large" @click="newCountryForm()">Agregar nuevo
            País</a-button></a-col>
        </a-row>
      </a-col>
      <a-col :span="10">
        <a-form v-if="countryFormIsOpen" layout="vertical" :form="formCountries" @submit="createCountry">
          <h1 class="titulo" style="font-weight: bold; font-size: 16px; margin-bottom: 20px">
            Crear Nuevo País:
          </h1>
          <a-form-item style="display: none;">
            <a-input v-decorator="['id']" class="shadowInputs" />
          </a-form-item>

          <a-form-item>
          <span slot="label">
            Nombre
          </span>
            <a-input v-decorator="[
            'name',
            {
              rules: [
                {
                  required: true,
                  message: 'Ingrese un nombre para este país',
                },
              ],
            },
          ]" class="shadowInputs" />
          </a-form-item>
          <a-form-item>
          <span slot="label">
            Emoji
          </span>
            <a-input v-decorator="[
            'emoji',
            {
              rules: [
                {
                  required: false,
                  message: 'Ingrese un emoji para este país',
                },
              ],
            },
          ]" class="shadowInputs" />
          </a-form-item>

          <a-form-item>
            <a-row type="flex" justify="end" align="middle" :gutter="20">
              <a-col><a-button type="primary" html-type="submit" size="large">Guardar</a-button></a-col>
              <a-col><a-button @click="countryFormIsOpen = false" size="large">Cancelar</a-button></a-col>
            </a-row>
          </a-form-item>
        </a-form>
      </a-col>
      <a-col :span="12" />
      <a-col :span="24"
             style=" word-break: break-all; background-color: white; padding: 20px 10px 5px; border-radius: 5px;"
             class="shadow">
        <a-row style="display: flex;  justify-content: flex-end; margin-bottom:20px">
          <a-input-search placeholder="Filtrar por Nombre" v-model="countryNameFilter" style="width: 200px;" />
        </a-row>
        <a-row>
          <a-table :columns="columnsListTable" :dataSource="filterCountries" rowKey="id" :pagination="pagination">
          </a-table>
        </a-row>
      </a-col>

    </a-row>
  </div>

</template>

<script>
import utils from '../service/service.js'
export default {
  name: "Categories",
  // props: {},
  mixins: [utils],
  data() {
    return {
      isAdmin: "0",
      countries: [],
      columnsListTable: [
        {
          title: "Id",
          dataIndex: "id",
        },
        {
          title: "",
          dataIndex: "emoji",
        },
        {
          title: "País",
          dataIndex: "name",
        }
      ],
      pagination: { pageSize: 8 },
      countryFormIsOpen: false,
      countryNameFilter: "",
      isEdit: false,
      formCountries: this.$form.createForm(this)
    };
  },
  mounted: function () {
    this.loadCountries();
  },
  methods: {
    createCountry(e) {
      e.preventDefault();
      this.formCountries.validateFields(async (err) => {
        if (err !== null) { return false; }
        const data = this.formCountries.getFieldsValue();
        let url = "";
        const { code } = await this.sendRequest({
          method: 'POST',
          url: 'countries/create',
          data: data,
        })
        if (code === 200) {
          this.$message.success('País creada')
          this.loadCountries();
          this.countryFormIsOpen = false;
        }
      });
    },
    newCountryForm() {
      this.formCountries.resetFields();
      this.countryFormIsOpen = true;
    },

    async loadCountries() {
      const { data } = await this.sendRequest({
        method: 'GET',
        url: 'countries/list',
      })

      this.countries = data;
    },
  },
  computed: {
    filterCountries() {
      var $this = this;
      return $this.countries.filter(function (data) {
        return (
            $this.countryNameFilter == "" ||
            data.name.toLowerCase().includes($this.countryNameFilter.toLowerCase())
        );
      });
    },
  },
};
</script>

<style scoped>
.titulo {
  font-size: 20px;
  font-weight: bold;
  text-align: left;
  color: #2c3e50;
}

.shadow {
  box-shadow: 2px 1px 5px -4px;
}

.shadowInputs {
  box-shadow: 1px 1px 5px -5px;
}
</style>
